module.exports = __webpack_public_path__ + "img/star-solid-dark.c18fd9b2.svg";